import React, { useEffect } from 'react';
import WithPosition from '../../components/common/hoc/resetPagePosition';
import "./home.css";
import TreeMenuPhoto from './Home.png';
import styled from 'styled-components';

const StyledButton = styled.div`
  background-color: ${props => props.backColor || "#04aa6d"}; 
  padding: 20px 40px;
  color: #ffffff;
  border-radius: 6px;
  cursor: pointer;
  font-size: 20px;
  transition: all 0.5s;
  &:hover {
    box-shadow: 5px 5px 5px #aaaaaa;
    padding: 25px 45px;
    font-size: 26px;
  }
`;

const StyledLink = styled.a`
  text-decoration:none;
  background-color: #0073a6; 
  padding: 20px 40px;
  color: #ffffff;
  border-radius: 6px;
  cursor: pointer;
  font-size: 20px;
  transition: all 0.5s;
  &:hover {
    box-shadow: 5px 5px 5px #aaaaaa;
    padding: 25px 45px;
    font-size: 26px;
  }
`;

const StyledContainer = styled.div`
width: 60%;
margin: auto;
display: flex;
justify-contents: space-btween;
padding: 40px;
gap: 20px;

@media (max-width: 768px) {
  flex-direction: column;
  width: 90%;
}

@media (max-width: 1024px) {
  width: 80%;
}


`;

const Home = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", padding: "40px", backgroundColor: "#DFECFC" }}>
        <div style={{ fontSize: "48px", fontWeight: "bold"}}>
        An 3D visualization application
        </div>
        <div style={{fontSize:"48px",fontWeight:"bold"}}>
        for Geophysicists and Geologists
        </div>
        <div style={{fontSize:"24px", marginTop:"30px",width:"610px", color: "#222"}}>
        High performance 3D rendering with easy navigation.
        </div>
        <div style={{fontSize:"24px", marginTop:"20px",width:"610px", color: "#222"}}>
        Easily build project with context menu.
        </div>
        <div style={{fontSize:"24px", marginTop:"20px",width:"610px", color: "#222"}}>
        Use JSON file format for the project.
        </div>
        <div style={{ fontSize: "24px", marginTop: "20px", width: "610px", color: "#222" }}>
            Flex layout help you customize your views.
        </div>
        <div style={{marginTop: '20px'}}>
          <StyledButton onClick={() => window.open("https://petro3d.github.io/")}>
            <span>Build your project online. It is free</span>
          </StyledButton>
        </div>
        <div style={{ fontSize: "24px", marginTop: "20px", width: "610px", color: "#222" }}>
            Download free desktop version.
        </div>
        <div style={{marginTop: '40px'}}>
          <StyledLink target='_blank'
            href="https://drive.usercontent.google.com/u/0/uc?id=1WqfCb5FTbyPcYS9-9UL9bg2omLVx9WE7&export=download"
          >
            Download Desktop Application
          </StyledLink>
        </div>
        <div style={{ fontSize: "24px", marginTop: "40px", width: "610px", color: "#222" }}>
            After download, unzip Petro3D.zip, then run Petro3D.exe.
        </div>

      </div>
      <div style={{backgroundColor: 'white', color: 'black'}}>
        <StyledContainer>
          <div style={{flex: 1, padding: '20px'}}>
            <img src={TreeMenuPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
          </div>
        </StyledContainer>
      </div>
    </div>
  )
}

export default WithPosition(Home);